import { render, staticRenderFns } from "./SignedCertUploadOverlay.vue?vue&type=template&id=227bea0f&scoped=true"
import script from "./SignedCertUploadOverlay.vue?vue&type=script&lang=js"
export * from "./SignedCertUploadOverlay.vue?vue&type=script&lang=js"
import style0 from "./SignedCertUploadOverlay.vue?vue&type=style&index=0&id=227bea0f&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227bea0f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('227bea0f')) {
      api.createRecord('227bea0f', component.options)
    } else {
      api.reload('227bea0f', component.options)
    }
    module.hot.accept("./SignedCertUploadOverlay.vue?vue&type=template&id=227bea0f&scoped=true", function () {
      api.rerender('227bea0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SignedCertUploadOverlay.vue"
export default component.exports